import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
// import PropTypes from 'prop-types'
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import React, { useState } from 'react';
import Select, { components } from 'react-select';
import styled from 'styled-components';
// import VirtualizedList from '../VirtualizedList'

const customStyles = {
  container: styles => (
    {
      ...styles,
      width: '100%'
    }
  ),
  control: (styles, { selectProps, menuIsOpen, isFocused }) => {
    const { value, options, isMulti } = selectProps;
    const newValue = Array.isArray(value) ? [...value] : !value ? [] : [value]
    const hasBgWhite = isMulti
                        ? (newValue.length > 0)
                        : (newValue.length > 0 && newValue.length < options[0].options.length);
    return ({
      ...styles,
      backgroundColor: hasBgWhite ? '#ffffff' : 'transparent',
      boxSizing: 'border-box',
      borderRadius: '12px',
      outline: 'none',
      padding: '2px 8px',
      display: 'flex',
      alignItems: 'center',
      border:
        selectProps.error
          ? '1px solid var(--main-error-color) !important'
          : menuIsOpen
            ? '1px solid #5E388A !important'
            : isFocused
              ? '1px solid #5E388A !important'
              : '1px solid #CCCCCC !important',
      boxShadow: 'none !important',
      '&:hover': {
        borderColor: menuIsOpen || isFocused ? null : 'rgba(0, 0, 0, 0.87) !important'
      }
    })
  },
  option: (styles, { data, isFocused, isSelected, selectProps }) => {
    const { value, options } = selectProps;
    const newValue = Array.isArray(value) ? [...value] : !value ? [] : [value]
    const hasCompleted = newValue.length === options[0].options.length;
    return {
      ...styles,
      backgroundColor: isSelected && !hasCompleted && !hasCompleted ?
        '#F0E6F2 !important' :
        'white !important',
      color: isSelected && !hasCompleted ? '#7C3F88 !important' : '#6A6A6A !important',
      // paddingLeft: '20px !important',
      transition: 'background-color 200ms ease-in-out',
      whiteSpace: 'nowrap',
      cursor: 'pointer',
      fontSize: '15px',
      lineHeight: '19px',
      fontWeight: isSelected && !hasCompleted ? 'bold !important' : null,
      '&:hover': {
        backgroundColor: isSelected && !hasCompleted ? '#F0E6F2 !important' : '#f0e6f285 !important',
      }
    };
  },
  valueContainer: styles => ({ ...styles, padding: '2px 0 2px 8px' }),
  dropdownIndicator: styles => ({ ...styles, padding: '8px 0' }),
  indicatorSeparator: styles => ({ ...styles, display: 'none' }),
  placeholder: (styles, { isFocused, isDisabled }) => ({
    ...styles,
    color: isDisabled ? '#cccccc' : isFocused ? '#5E388A' : '#6A6A6A',
    fontSize: '16px',
    lineHeight: '18px',
  }),
  input: styles => ({ ...styles, color: 'black !important' }),
  menu: styles => ({
    ...styles,
    // margin: 0,
    width: 'auto',
    minWidth: '100%',
    boxShadow: '0px 0px 1px rgba(0, 0, 0, 0.16), 0px 1px 4px rgba(0, 0, 0, 0.16)',
    borderRadius: '10px',
    // boxShadow: '0 0 0 2px rgba(119,48,100,.25) !important'
  }),
  group: styles => ({ ...styles, paddingTop: 0, paddingBottom: 0 }),
  groupHeading: styles => ({ ...styles, padding: '0px', marginBottom: 0 }),
  singleValue: styles => ({ ...styles, fontWeight: 500, fontSize: '14px', lineHeight: '18px', color: '#5E388A'})

}
const GroupStyles = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  line-height: 20px;
  color: #333333;
  font-weight: 500;
  text-transform: none;
  white-space: nowrap;
  padding: 8px 12px;
`
const GroupAllStyles = styled.div`
  cursor: pointer;
  background-color: ${({ selected }) =>
    selected
      ? '#F0E6F2 !important'
      : 'white !important'
  };
  color: ${({ selected }) => selected ? '#7C3F88 !important' : '#6A6A6A !important'};
  font-weight: ${({ selected }) => selected ? 'bold !important' : 'normal'};
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 15px;
  line-height: 19px;
  color: #6A6A6A;
  transition: background-color 200ms ease-in-out;
  text-transform: none;
  white-space: nowrap;
  padding: 8px 12px;
  &:hover{
    background-color: ${({ selected }) => selected ? '#F0E6F2 !important' : '#f0e6f285 !important'};
  }
`
const CrossStyle = styled.div`
  cursor: pointer;
`
const CrossStylePurple = styled.div`
  cursor: pointer;
  margin-left: .3em;
`
const MultiValueLabel = styled.div`
  font-family: Open Sans;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: #5E388A;
`

const voidFunc = () => { }

const DropdownIndicator = props => {
  return (
    <components.DropdownIndicator {...props}>
      {
        props.isFocused
          ? <ArrowDropUpIcon style={{ color: !props.isDisabled ? '#5E388A' : '#cccccc' }} />
          : <ArrowDropDownIcon style={{ color: !props.isDisabled ?  '#5E388A' : '#cccccc' }} />
      }
    </components.DropdownIndicator>
  );
};

const MultiValueContainer = props => {
  const values = props.selectProps.value;
  if(values[0].label !== props.data.label) return <></> ;
  return (
    <MultiValueLabel>{values[0].label} {values.length-1 === 0 ? `` : `+${values.length-1}`}</MultiValueLabel>
  );
};

const ValueContainer = ({ children, ...props }) => {
  const { value, options, isMulti } = props.selectProps;
  const newValue = Array.isArray(value) ? [...value] : !value ? [] : [value]
  const hasCross = isMulti
                      ? (newValue.length > 0)
                      : (newValue.length > 0 && newValue.length < options[0].options.length);
  return (
    <>
      {hasCross &&
        <CrossStylePurple onClick={() => props.clearValue()}>
          <img src={require('../../../../assets/icons/cross_purple.svg')} alt='cross'/>
        </CrossStylePurple>
      }
      <components.ValueContainer {...props}>{children}</components.ValueContainer>
    </>
  )
};

const CustomSelect = ({ value = [], options, onChange = voidFunc, placeholder = 'Seleccionar', disabled, multi, allLabel=true }) => {

  const [menuIsOpen, setMenuIsOpen] = useState(false)

  const formatGroupLabel = (data, placeholder) => {
    // console.log(data);
    const valueCompleted = data.options.length === (value && value.length);
    return (
      <>
        <GroupStyles>
          <span>{data.label}</span>
          <CrossStyle onClick={() => setMenuIsOpen(false)}><img src={require('../../../../assets/icons/cross.svg')} alt='cross' /></CrossStyle>
          {/* <span style={groupBadgeStyles}>{data.options.length}</span> */}
        </GroupStyles>
        { allLabel &&
          <GroupAllStyles
            selected={valueCompleted}
            onClick={() => valueCompleted ? onChange([]) : onChange(data.options)}>
          <span>Todas las {placeholder.toLowerCase()}</span>
          </GroupAllStyles>
        }
      </>
    )
  };

  const Option = ({ children, ...props }) => {
    const { onMouseMove, onMouseOver, ...rest } = props.innerProps;
    const newProps = Object.assign(props, { innerProps: rest });
    return (
      <components.Option
        {...newProps}
      >
        {children}
      </components.Option>
    );
  };

  return (
    <Select
      options={options}
      menuIsOpen={menuIsOpen}
      placeholder={placeholder}
      isDisabled={disabled}
      // captureMenuScroll={false}
      components={{
        DropdownIndicator,
        MultiValueContainer,
        ValueContainer,
        // MenuList: VirtualizedList,
        Option
      }}
      noOptionsMessage={() => 'No hay opciones'}
      // filterOption={createFilter({ ignoreAccents: false })} // this makes all the difference!
      onFocus={() => setMenuIsOpen(true)}
      onBlur={() => setMenuIsOpen(false)}
      value={value}
      onChange={onChange}
      styles={customStyles}
      isClearable={false}
      controlShouldRenderValue={(options[0].options.length === (value && value.length) && !multi) ? false : true}
      formatGroupLabel={(data) => formatGroupLabel(data, placeholder, onChange)}
      // isClearable={true}
      // formatOptionLabel={formatOptionLabel}
      // isOptionSelected={(a, b) => false}
      isSearchable={true}
      isMulti={multi}
      hideSelectedOptions={false}
    />
  )
}

CustomSelect.propTypes = {

}

export default CustomSelect
